import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const AutomationLogExecutionStatusKeys = new Set(['automation_log_steps.status'])

export const isAutomationLogExecutionStatusWidget = <T extends IFilterValue, C>(
  filterItem: FilterItem<T, C>
) => AutomationLogExecutionStatusKeys.has(filterItem.key)
